import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommBoxPlusIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M6 15.25C5.58579 15.25 5.25 15.5858 5.25 16 5.25 16.4142 5.58579 16.75 6 16.75H8C8.41421 16.75 8.75 16.4142 8.75 16 8.75 15.5858 8.41421 15.25 8 15.25H6zM15 15.25C14.5858 15.25 14.25 15.5858 14.25 16 14.25 16.4142 14.5858 16.75 15 16.75H16.25V18C16.25 18.4142 16.5858 18.75 17 18.75 17.4142 18.75 17.75 18.4142 17.75 18V16.75H19C19.4142 16.75 19.75 16.4142 19.75 16 19.75 15.5858 19.4142 15.25 19 15.25H17.75V14C17.75 13.5858 17.4142 13.25 17 13.25 16.5858 13.25 16.25 13.5858 16.25 14V15.25H15z"
            fill="#222"
          />
          <path
            d="M5.125 20.75H13.759C14.6819 21.381 15.7979 21.75 17 21.75C20.1763 21.75 22.75 19.1751 22.75 16C22.75 14.2573 21.9747 12.6955 20.75 11.6409V7.855C20.75 7.46696 20.6716 7.08337 20.5204 6.72709L19.3526 3.9952C18.8998 2.93818 17.8609 2.25 16.709 2.25H6.292C5.1407 2.25 4.10039 2.93712 3.64837 3.9952L2.48191 6.72393C2.32842 7.08142 2.25 7.46769 2.25 7.855V17.875C2.25 19.4632 3.53679 20.75 5.125 20.75ZM5.02772 4.58459C5.24375 4.07879 5.74137 3.75 6.292 3.75H10.75V6.69043H4.12753L5.02772 4.58459ZM3.75 8.19043V17.875C3.75 18.6348 4.36521 19.25 5.125 19.25H12.2562C11.6215 18.3254 11.25 17.206 11.25 16C11.25 12.8248 13.8248 10.25 17 10.25C17.7985 10.25 18.559 10.4127 19.25 10.7068V8.19043H3.75ZM14.4418 19.3938L14.4583 19.4062C15.1672 19.9362 16.047 20.25 17 20.25C19.3477 20.25 21.25 18.3469 21.25 16C21.25 14.6172 20.5896 13.3885 19.5668 12.6123C19.5555 12.6043 19.5444 12.5959 19.5335 12.5873C18.8261 12.0613 17.9495 11.75 17 11.75C14.6532 11.75 12.75 13.6532 12.75 16C12.75 17.3864 13.4142 18.618 14.4418 19.3938ZM18.8735 6.69043L17.9736 4.58533C17.7564 4.07836 17.2591 3.75 16.709 3.75H12.25V6.69043H18.8735Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
